(() => {
  function init(scope=document) {
    scope.querySelectorAll('[data-tackle-page]').forEach(root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';
      const form=root.querySelector('[data-tackle-filters]');if(!form)return;
      const selects=[...form.querySelectorAll('[data-tackle-filter]')];form.hidden=false;
      form.addEventListener('submit',event=>{
        event.preventDefault();
        const known=new Set(selects.flatMap(s=>[...s.options].map(o=>o.value)));
        const current=JSON.parse(root.querySelector('[data-tackle-current-tags]').textContent)||[];
        const tags=[...new Set([...current.filter(t=>!known.has(t)),...selects.map(s=>s.value).filter(Boolean)])];
        const url=new URL(root.dataset.collectionUrl,location.origin);
        if(tags.length)url.pathname+='/'+tags.map(encodeURIComponent).join('+');
        for(const [key,value]of new URLSearchParams(location.search))if(key.startsWith('filter.')||key==='sort_by')url.searchParams.append(key,value);
        url.hash='TackleProducts';location.assign(url);
      });
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
